import React from 'react'
import './Footer.css'

export default function Footer(props) {
  return <footer>Copyright Alchemy Codelab {props.year}</footer>
}
